import React from "react";
import { Phone, Mail, MapPin, Instagram, Facebook, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/Lang";
import { CONTACT, SERVICES } from "@/data";
import logo from "@/assets/logo.png";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  const { t, lang } = useLang();
  const links = [
    { id: "services", label: t.nav.services },
    { id: "gallery", label: t.nav.gallery },
    { id: "why", label: t.nav.why },
    { id: "reviews", label: t.nav.reviews },
    { id: "quote", label: t.nav.book },
  ];
  return (
    <footer className="bg-navy-deep grain relative border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={logo} alt="Seven Home Services" className="h-14 w-auto" />
          <p className="mt-4 text-white/55 text-sm leading-relaxed max-w-xs">
            {t.footer.tagline}
          </p>
          <div className="mt-5 inline-flex items-center gap-2 text-gold text-sm font-semibold">
            <ShieldCheck size={16} /> Licensed & Insured
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm tracking-widest uppercase">{t.footer.quick}</h4>
          <ul className="space-y-2.5">
            {links.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollTo(l.id)} className="text-white/55 hover:text-orange text-sm transition-colors">{l.label}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm tracking-widest uppercase">{t.footer.servicesTitle}</h4>
          <ul className="space-y-2.5">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id} className="text-white/55 text-sm">{s[lang].title}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm tracking-widest uppercase">{t.footer.contact}</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={CONTACT.phoneHref} className="flex items-center gap-3 text-white/70 hover:text-orange transition-colors"><Phone size={16} /> {CONTACT.phoneDisplay}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-white/70 hover:text-orange transition-colors"><Mail size={16} /> {CONTACT.email}</a></li>
            <li className="flex items-center gap-3 text-white/70"><MapPin size={16} /> {CONTACT.address}</li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href="https://www.instagram.com/seven_homeservices" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/70 hover:bg-orange hover:border-orange hover:text-white transition-colors"><Instagram size={16} /></a>
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/70 hover:bg-orange hover:border-orange hover:text-white transition-colors"><Facebook size={16} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/40 text-xs">
        © {new Date().getFullYear()} Seven Home Services. {t.footer.rights}
      </div>
    </footer>
  );
}
